"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StrikerRoleBonuses = exports.StrikerExpandedRoles = void 0;
// strikerRoles.ts
const playerBonuses_1 = require("../playerBonuses");
const playerTraits_1 = require("../playerTraits");
const rarity_1 = require("../rarity");
const zones_1 = require("../zones");
const baseRoles_1 = require("./baseRoles");
var StrikerExpandedRoles;
(function (StrikerExpandedRoles) {
    // --- Uncommon --- GENERIC (similar to AM for consistency)
    StrikerExpandedRoles["RAPID_STRIKER"] = "RAPID_STRIKER";
    StrikerExpandedRoles["POWERFUL_STRIKER"] = "POWERFUL_STRIKER";
    StrikerExpandedRoles["TIRELESS_STRIKER"] = "TIRELESS_STRIKER";
    StrikerExpandedRoles["DETERMINED_STRIKER"] = "DETERMINED_STRIKER";
    StrikerExpandedRoles["HEROIC_STRIKER"] = "HEROIC_STRIKER";
    StrikerExpandedRoles["ECCENTRIC_STRIKER"] = "ECCENTRIC_STRIKER";
    StrikerExpandedRoles["RELIABLE_STRIKER"] = "RELIABLE_STRIKER";
    StrikerExpandedRoles["LUCKY_STRIKER"] = "LUCKY_STRIKER";
    // STUBBORN_STRIKER for Unyielding might be less common for ST, can be omitted or given 'shoot'
    StrikerExpandedRoles["TENACIOUS_STRIKER"] = "TENACIOUS_STRIKER";
    StrikerExpandedRoles["INSPIRATIONAL_STRIKER"] = "INSPIRATIONAL_STRIKER";
    StrikerExpandedRoles["DOMINANT_STRIKER"] = "DOMINANT_STRIKER";
    StrikerExpandedRoles["IMPACT_STRIKER"] = "IMPACT_STRIKER";
    StrikerExpandedRoles["PRESSING_FORWARD"] = "PRESSING_FORWARD";
    StrikerExpandedRoles["VOCAL_STRIKER"] = "VOCAL_STRIKER";
    StrikerExpandedRoles["EXPERIENCED_STRIKER"] = "EXPERIENCED_STRIKER";
    // --- Uncommon --- STRIKER SPECIFIC / ATTACKING FOCUS
    StrikerExpandedRoles["STAR_STRIKER"] = "STAR_STRIKER";
    StrikerExpandedRoles["SILKY_STRIKER"] = "SILKY_STRIKER";
    StrikerExpandedRoles["LETHAL_STRIKER"] = "LETHAL_STRIKER";
    StrikerExpandedRoles["PROLIFIC_STRIKER"] = "PROLIFIC_STRIKER";
    StrikerExpandedRoles["PENETRATING_STRIKER"] = "PENETRATING_STRIKER";
    StrikerExpandedRoles["OUTLET_FORWARD"] = "OUTLET_FORWARD";
    StrikerExpandedRoles["PLAYMAKING_FORWARD"] = "PLAYMAKING_FORWARD";
    StrikerExpandedRoles["ROAMING_FORWARD"] = "ROAMING_FORWARD";
    StrikerExpandedRoles["ORCHESTRATING_FORWARD"] = "ORCHESTRATING_FORWARD";
    // Add other specific striking traits if available e.g. PRESS_RESISTANT -> ELUSIVE_STRIKER
    StrikerExpandedRoles["FIREY_STRIKER"] = "FIREY_STRIKER";
    StrikerExpandedRoles["VERSATILE_STRIKER"] = "VERSATILE_STRIKER";
    // --- Rare --- GENERIC COMBINATIONS
    StrikerExpandedRoles["ATHLETIC_STRIKER"] = "ATHLETIC_STRIKER";
    StrikerExpandedRoles["ENERGETIC_STRIKER"] = "ENERGETIC_STRIKER";
    StrikerExpandedRoles["VALIANT_STRIKER"] = "VALIANT_STRIKER";
    StrikerExpandedRoles["PLUCKY_STRIKER"] = "PLUCKY_STRIKER";
    StrikerExpandedRoles["GEGEN_PRESSING_FORWARD"] = "GEGEN_PRESSING_FORWARD";
    StrikerExpandedRoles["COMMANDING_STRIKER"] = "COMMANDING_STRIKER";
    StrikerExpandedRoles["ROUSING_STRIKER"] = "ROUSING_STRIKER";
    // --- Rare --- ARCHETYPAL STRIKERS
    StrikerExpandedRoles["POACHER"] = "POACHER";
    StrikerExpandedRoles["ADVANCED_FORWARD"] = "ADVANCED_FORWARD";
    StrikerExpandedRoles["TRICKY_FINISHER"] = "TRICKY_FINISHER";
    StrikerExpandedRoles["DOMINANT_TARGET_MAN"] = "DOMINANT_TARGET_MAN";
    StrikerExpandedRoles["DEEP_LYING_FORWARD"] = "DEEP_LYING_FORWARD";
    StrikerExpandedRoles["COMPLETE_FORWARD"] = "COMPLETE_FORWARD";
    StrikerExpandedRoles["ASSASSIN"] = "ASSASSIN";
    StrikerExpandedRoles["OLD_FASHIONED_NUMBER_NINE"] = "OLD_FASHIONED_NUMBER_NINE";
    StrikerExpandedRoles["HOLD_UP_SPECIALIST"] = "HOLD_UP_SPECIALIST";
    StrikerExpandedRoles["FALSE_NINE"] = "FALSE_NINE";
    StrikerExpandedRoles["TARGET_MAN"] = "TARGET_MAN";
    StrikerExpandedRoles["PREDATOR"] = "PREDATOR";
    StrikerExpandedRoles["TAP_IN_MERCHANT"] = "TAP_IN_MERCHANT";
    StrikerExpandedRoles["LETHAL_GOAL_MACHINE"] = "LETHAL_GOAL_MACHINE";
    StrikerExpandedRoles["RAUMDAUTER"] = "RAUMDAUTER";
    StrikerExpandedRoles["HOT_SHOT"] = "HOT_SHOT";
})(StrikerExpandedRoles || (exports.StrikerExpandedRoles = StrikerExpandedRoles = {}));
exports.StrikerRoleBonuses = {
    [baseRoles_1.BaseRoles.STRIKER]: {
        rarity: rarity_1.Rarity.COMMON,
        statBlock: {
            shoot: playerBonuses_1.PlayerBonuses.MAIN_POSITION_ATTRIBUTE,
            run: playerBonuses_1.PlayerBonuses.SECOND_POSITION_ATTRIBUTE,
            pass: playerBonuses_1.PlayerBonuses.THIRD_POSITION_ATTRIBUTE,
        },
        positionsEnabled: [zones_1.Zones.ATTACK],
        playerTraits: [],
    },
    // --- Uncommon --- GENERIC ---
    [StrikerExpandedRoles.RAPID_STRIKER]: {
        parentRoles: [baseRoles_1.BaseRoles.STRIKER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { run: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.RAPID],
    },
    [StrikerExpandedRoles.POWERFUL_STRIKER]: {
        parentRoles: [baseRoles_1.BaseRoles.STRIKER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { shoot: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.POWERFUL],
    },
    [StrikerExpandedRoles.TIRELESS_STRIKER]: {
        parentRoles: [baseRoles_1.BaseRoles.STRIKER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { run: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.STAMINA],
    },
    [StrikerExpandedRoles.DETERMINED_STRIKER]: {
        parentRoles: [baseRoles_1.BaseRoles.STRIKER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { shoot: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.DETERMINED],
    },
    [StrikerExpandedRoles.HEROIC_STRIKER]: {
        parentRoles: [baseRoles_1.BaseRoles.STRIKER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { shoot: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.HERO],
    },
    [StrikerExpandedRoles.ECCENTRIC_STRIKER]: {
        parentRoles: [baseRoles_1.BaseRoles.STRIKER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { run: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.FLAIR],
    },
    [StrikerExpandedRoles.RELIABLE_STRIKER]: {
        parentRoles: [baseRoles_1.BaseRoles.STRIKER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { shoot: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.RELIABLE],
    },
    [StrikerExpandedRoles.LUCKY_STRIKER]: {
        parentRoles: [baseRoles_1.BaseRoles.STRIKER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { shoot: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.LUCKY],
    },
    [StrikerExpandedRoles.TENACIOUS_STRIKER]: {
        parentRoles: [baseRoles_1.BaseRoles.STRIKER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { run: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.UNDERDOG],
    },
    [StrikerExpandedRoles.INSPIRATIONAL_STRIKER]: {
        parentRoles: [baseRoles_1.BaseRoles.STRIKER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { shoot: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.INSPIRE],
    },
    [StrikerExpandedRoles.DOMINANT_STRIKER]: {
        parentRoles: [baseRoles_1.BaseRoles.STRIKER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { shoot: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.DOMINANT],
    },
    [StrikerExpandedRoles.IMPACT_STRIKER]: {
        parentRoles: [baseRoles_1.BaseRoles.STRIKER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { shoot: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.SUPER_SUB],
    },
    [StrikerExpandedRoles.PRESSING_FORWARD]: {
        parentRoles: [baseRoles_1.BaseRoles.STRIKER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { intercept: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Increased run for pressing (corrected stat)
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.PRESSING],
    },
    [StrikerExpandedRoles.VOCAL_STRIKER]: {
        parentRoles: [baseRoles_1.BaseRoles.STRIKER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { pass: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Organising attack/link-up
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.ORGANISED],
    },
    [StrikerExpandedRoles.EXPERIENCED_STRIKER]: {
        parentRoles: [baseRoles_1.BaseRoles.STRIKER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { shoot: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Wise positioning for scoring
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.WISE],
    },
    // --- Uncommon --- STRIKER SPECIFIC / ATTACKING FOCUS ---
    [StrikerExpandedRoles.STAR_STRIKER]: {
        parentRoles: [baseRoles_1.BaseRoles.STRIKER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { shoot: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.STAR],
    },
    [StrikerExpandedRoles.SILKY_STRIKER]: {
        parentRoles: [baseRoles_1.BaseRoles.STRIKER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { pass: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Good touch to set up a shot
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.FIRST_TOUCH],
    },
    [StrikerExpandedRoles.LETHAL_STRIKER]: {
        parentRoles: [baseRoles_1.BaseRoles.STRIKER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { shoot: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.LETHAL],
    },
    [StrikerExpandedRoles.PROLIFIC_STRIKER]: {
        parentRoles: [baseRoles_1.BaseRoles.STRIKER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { shoot: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.GOAL_MACHINE],
    },
    [StrikerExpandedRoles.PENETRATING_STRIKER]: {
        parentRoles: [baseRoles_1.BaseRoles.STRIKER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { run: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.CHARGE],
    },
    [StrikerExpandedRoles.OUTLET_FORWARD]: {
        // Was Target Man Striker
        parentRoles: [baseRoles_1.BaseRoles.STRIKER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { pass: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Holding up and laying off
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.TARGET],
    },
    [StrikerExpandedRoles.PLAYMAKING_FORWARD]: {
        // Was Playmaking Striker
        parentRoles: [baseRoles_1.BaseRoles.STRIKER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { pass: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.PLAYMAKER],
    },
    [StrikerExpandedRoles.ROAMING_FORWARD]: {
        // Was Roaming Striker
        parentRoles: [baseRoles_1.BaseRoles.STRIKER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { run: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // To get into half-spaces
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.HALF_SPACES],
    },
    [StrikerExpandedRoles.ORCHESTRATING_FORWARD]: {
        parentRoles: [baseRoles_1.BaseRoles.STRIKER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { pass: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.SHORT_PASS],
    },
    [StrikerExpandedRoles.FIREY_STRIKER]: {
        parentRoles: [baseRoles_1.BaseRoles.STRIKER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { tackle: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.IGNITE],
    },
    [StrikerExpandedRoles.VERSATILE_STRIKER]: {
        parentRoles: [baseRoles_1.BaseRoles.STRIKER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { pass: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.VERSATILE],
    },
    // --- Rare --- GENERIC COMBINATIONS ---
    [StrikerExpandedRoles.ATHLETIC_STRIKER]: {
        parentRoles: [
            StrikerExpandedRoles.RAPID_STRIKER,
            StrikerExpandedRoles.POWERFUL_STRIKER,
        ],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { run: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [],
    },
    [StrikerExpandedRoles.ENERGETIC_STRIKER]: {
        parentRoles: [
            StrikerExpandedRoles.RAPID_STRIKER,
            StrikerExpandedRoles.TIRELESS_STRIKER,
        ],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { run: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [],
    },
    [StrikerExpandedRoles.VALIANT_STRIKER]: {
        parentRoles: [
            StrikerExpandedRoles.DETERMINED_STRIKER,
            StrikerExpandedRoles.HEROIC_STRIKER,
        ],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { shoot: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [],
    },
    [StrikerExpandedRoles.PLUCKY_STRIKER]: {
        parentRoles: [
            StrikerExpandedRoles.LUCKY_STRIKER,
            StrikerExpandedRoles.TENACIOUS_STRIKER,
        ],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { shoot: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Plucky goals
        positionsEnabled: [],
        playerTraits: [],
    },
    [StrikerExpandedRoles.GEGEN_PRESSING_FORWARD]: {
        parentRoles: [
            StrikerExpandedRoles.PRESSING_FORWARD,
            StrikerExpandedRoles.ORCHESTRATING_FORWARD,
        ],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { intercept: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Pressing leads to intercepts
        positionsEnabled: [],
        playerTraits: [],
    },
    [StrikerExpandedRoles.COMMANDING_STRIKER]: {
        parentRoles: [
            StrikerExpandedRoles.EXPERIENCED_STRIKER,
            StrikerExpandedRoles.VOCAL_STRIKER,
        ],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { pass: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Dictating play/organising attack
        positionsEnabled: [],
        playerTraits: [],
    },
    [StrikerExpandedRoles.ROUSING_STRIKER]: {
        parentRoles: [
            StrikerExpandedRoles.INSPIRATIONAL_STRIKER,
            StrikerExpandedRoles.DETERMINED_STRIKER,
        ],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { shoot: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [],
    },
    // --- Rare --- ARCHETYPAL STRIKERS ---
    [StrikerExpandedRoles.POACHER]: {
        parentRoles: [
            StrikerExpandedRoles.LETHAL_STRIKER,
            StrikerExpandedRoles.SILKY_STRIKER,
        ],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { shoot: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [],
    },
    [StrikerExpandedRoles.ADVANCED_FORWARD]: {
        parentRoles: [
            StrikerExpandedRoles.RAPID_STRIKER,
            StrikerExpandedRoles.LETHAL_STRIKER,
        ],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { shoot: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [],
    },
    [StrikerExpandedRoles.TRICKY_FINISHER]: {
        parentRoles: [
            StrikerExpandedRoles.ECCENTRIC_STRIKER,
            StrikerExpandedRoles.LETHAL_STRIKER,
        ],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { shoot: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [],
    },
    [StrikerExpandedRoles.DOMINANT_TARGET_MAN]: {
        parentRoles: [
            StrikerExpandedRoles.POWERFUL_STRIKER,
            StrikerExpandedRoles.OUTLET_FORWARD,
        ],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { shoot: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [],
    },
    [StrikerExpandedRoles.DEEP_LYING_FORWARD]: {
        parentRoles: [
            StrikerExpandedRoles.ROAMING_FORWARD,
            StrikerExpandedRoles.SILKY_STRIKER,
        ],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { pass: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [],
    },
    [StrikerExpandedRoles.COMPLETE_FORWARD]: {
        parentRoles: [
            StrikerExpandedRoles.PENETRATING_STRIKER,
            StrikerExpandedRoles.ORCHESTRATING_FORWARD,
        ],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { shoot: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // A complete forward should still score
        positionsEnabled: [],
        playerTraits: [],
    },
    [StrikerExpandedRoles.ASSASSIN]: {
        // Renamed from SUPER_SUB
        parentRoles: [
            StrikerExpandedRoles.LETHAL_STRIKER,
            StrikerExpandedRoles.IMPACT_STRIKER,
        ],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { shoot: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [],
    },
    [StrikerExpandedRoles.OLD_FASHIONED_NUMBER_NINE]: {
        parentRoles: [
            StrikerExpandedRoles.LETHAL_STRIKER,
            StrikerExpandedRoles.OUTLET_FORWARD,
        ],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { shoot: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [],
    },
    [StrikerExpandedRoles.HOLD_UP_SPECIALIST]: {
        parentRoles: [
            StrikerExpandedRoles.OUTLET_FORWARD,
            StrikerExpandedRoles.ORCHESTRATING_FORWARD,
        ],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { pass: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [],
    },
    [StrikerExpandedRoles.FALSE_NINE]: {
        parentRoles: [
            StrikerExpandedRoles.ORCHESTRATING_FORWARD,
            StrikerExpandedRoles.ROAMING_FORWARD,
        ],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { pass: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [],
    },
    [StrikerExpandedRoles.TARGET_MAN]: {
        parentRoles: [
            StrikerExpandedRoles.OUTLET_FORWARD,
            StrikerExpandedRoles.POWERFUL_STRIKER,
        ],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { shoot: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [],
    },
    [StrikerExpandedRoles.PREDATOR]: {
        parentRoles: [
            StrikerExpandedRoles.LETHAL_STRIKER,
            StrikerExpandedRoles.POWERFUL_STRIKER,
        ],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { shoot: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [],
    },
    [StrikerExpandedRoles.TAP_IN_MERCHANT]: {
        parentRoles: [
            StrikerExpandedRoles.ORCHESTRATING_FORWARD,
            StrikerExpandedRoles.LETHAL_STRIKER,
        ],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { shoot: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [],
    },
    [StrikerExpandedRoles.LETHAL_GOAL_MACHINE]: {
        // Renamed from GOAL_MACHINE
        parentRoles: [
            StrikerExpandedRoles.LETHAL_STRIKER,
            StrikerExpandedRoles.PROLIFIC_STRIKER,
        ],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { shoot: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [],
    },
    [StrikerExpandedRoles.RAUMDAUTER]: {
        parentRoles: [
            StrikerExpandedRoles.LETHAL_STRIKER,
            StrikerExpandedRoles.ROAMING_FORWARD,
        ],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { shoot: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [],
    },
    [StrikerExpandedRoles.HOT_SHOT]: {
        parentRoles: [
            StrikerExpandedRoles.FIREY_STRIKER,
            StrikerExpandedRoles.LETHAL_STRIKER,
        ],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { shoot: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [], // Inherits IGNITE and LETHAL
    },
};
